

function initBitrixChatWithUser(hash, firstName, lastName, email, userType) {
    window.addEventListener('onBitrixLiveChat', function (event) {
        var widget = event.detail.widget;
        // Settings external user authentication
        widget.setUserRegisterData({
            'hash': hash,
            'name': firstName,
            'lastName': lastName,
            'email': email,
            'www': 'https://app.korvilabs.com',
            'position': userType
        });
    });
}
